import {POSTERMYWALL_SUBMIT_BUTTON_TYPE} from '@FormMakerReact/components/postermywall-submit-button/postermywall-submit-button';
import {POSTERMYWALL_CONFIRMATION_PANEL_BUTTON_TYPE} from '@FormMakerReact/components/postermywall-confirmation-panel-button/postermywall-confirmation-panel-button';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {SubmitButtonBgColorControl} from './components/submit-button-bg-color-control/submit-button-bg-color-control';
import {SubmitButtonBorderColorControl} from './components/submit-button-border-color-control/submit-button-border-color-control';
import {SubmitButtonBorderWidthControl} from './components/submit-button-border-width-control/submit-button-border-width-control';
import {SubmitButtonFontControl} from './components/submit-button-font-control/submit-button-font-control';
import {SubmitButtonRoundnessControl} from './components/submit-button-roundness-control/submit-button-roundness-control';
import {SubmitButtonSizeControl} from './components/submit-button-size-control/submit-button-size-control';
import {SubmitButtonTextColorControl} from './components/submit-button-text-color-control/submit-button-text-color-control';

const SECTOR = {
  title: window.i18next.t('pmwjs_form_maker_name_button'),
  controls: [
    SubmitButtonTextColorControl,
    SubmitButtonBgColorControl,
    SubmitButtonFontControl,
    SubmitButtonSizeControl,
    SubmitButtonBorderWidthControl,
    SubmitButtonBorderColorControl,
    SubmitButtonRoundnessControl,
  ],
};

registerRightPanelSector(POSTERMYWALL_SUBMIT_BUTTON_TYPE, SECTOR);
registerRightPanelSector(POSTERMYWALL_CONFIRMATION_PANEL_BUTTON_TYPE, SECTOR);
